var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 129,
    viewBox: "0 0 143 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.567597 128.344V67.3386C0.245178 58.9321 1.53083 50.5414 4.35552 42.6172C6.993 35.1733 10.9805 28.2796 16.1181 22.2818C21.2334 16.3533 27.3799 11.4 34.2603 7.66173C41.3718 3.78554 49.1497 1.28304 57.1873 0.285156V26.6014C47.0861 30.0571 40.1748 35.1742 36.4533 41.9526C32.7318 48.731 30.8711 57.0379 30.8711 66.8733H57.1873V128.344H0.567597ZM85.4971 128.344V67.3386C85.1747 58.9321 86.4604 50.5414 89.285 42.6172C91.9225 35.1733 95.91 28.2796 101.048 22.2818C106.163 16.3533 112.309 11.4 119.19 7.66173C126.301 3.78554 134.079 1.28304 142.117 0.285156V26.6014C132.016 30.0571 125.104 35.1742 121.383 41.9526C117.661 48.731 115.801 57.0379 115.801 66.8733H142.117V128.344H85.4971Z",
    fill: "#42D3AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f58ef786b8fb2f3c7a1ce29c943f340e.svg";
export { ForwardRef as ReactComponent };